import ManualSearch from './ManualSearch';

export default ManualSearch;
